import { GAME_CONFIG } from './gameConfig';

export const createInitialRuntimeState = () => ({
  phase: 'menu',
  score: 0,
  streakTime: 0,
  maxStreakTime: 0,
  multiplier: 1,
  elapsedTime: 0,
  timeLeft: GAME_CONFIG.time.initial,
  totalHits: 0,
  totalMisses: 0,
  combo: 0,
  maxCombo: 0,
  judgements: { perfect: 0, great: 0, good: 0 },
  accuracyWeight: 0,
  streakStartedAt: null,
  lastHudUpdate: -Infinity,
  lastBeat: -1,
  laneFeedback: { left: null, right: null },
  holdFeedback: { left: null, right: null },
  smileUntil: 0,
  announcementUntil: 0,
  resumeHoldUntil: 0,
  gameStartTime: 0,
  gameStartAtMs: 0,
  nextSpawnTick: 0,
  nextSpawnEventIndex: 0,
  lastCountUI: 3,
  currentTolerance: 3.0,
  currentSpeed: 1.0,
  currentStageId: 'intro',
});
